import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createHead } from '@unhead/vue'
import VueGtag from "vue-gtag"
import { createGtm } from '@gtm-support/vue-gtm'

import { GA_ID, GTM_ID } from "@/constants.js"

import VueCookies from "vue-cookies"

const head = createHead()

const app = createApp(App)
    .use(VueCookies)
    .use(store)
    .use(router)
    .use(head)

if (GA_ID) {
    app.use(VueGtag, {
        config: { id: GA_ID },
        enabled: false,
    })
}

// createGtm throws unless the id matches /^GTM-[0-9A-Z]+$/; unguarded, that
// aborts the mount below and leaves the raw WordPress markup on screen.
if (GTM_ID) {
    app.use(createGtm({
        id: GTM_ID,
    }))
}

app.mount('body')
